import { isExternalUrl } from '@/util/isExternalUrl';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import styles from './Html.module.scss';

export function Html({ html }: { html: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const router = useRouter();

  useEffect(() => {
    const rootEl = ref.current;
    if (!rootEl) return;

    // Remove unnecessary empty paragraphs.
    const div = document.createElement('div');
    div.innerHTML = html;
    div.querySelectorAll('p').forEach((el) => {
      const isEmpty =
        (el.textContent || '').trim().length === 0 && el.children.length === 0;

      if (isEmpty) {
        el.remove();
      }
    });

    rootEl.innerHTML = div.innerHTML;

    // Pass internal links through the router.
    rootEl.querySelectorAll('a').forEach((el) => {
      if (!isExternalUrl(el.href)) {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          router.push(el.href);
        });
      }
    });
  }, [html, router]);

  return (
    <div
      ref={ref}
      className={styles.Html}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
